import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Layout, Hero, AboutBusiness, Services, Contact } from '../components';

const StyledMainContainer = styled.main`
  counter-reset: section;
`;

const IndexPage = ({ location }) => (
  <Layout location={location}>
    <StyledMainContainer className="fillHeight">
      <Hero />
      {/* Business-focused About section */}
      <AboutBusiness />
      <Services />
      {/* Personal sections - commented out for business page redesign */}
      {/* <About /> */}
      {/* <Jobs /> */}
      {/* <Education /> */}
      {/* <Certification /> */}
      {/* <Publications /> */}
      <Contact />
    </StyledMainContainer>
  </Layout>
);

IndexPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default IndexPage;
